module.exports = __webpack_public_path__ + "static/media/AnalyticTool.dbfb433d.png";